import { rewordValidationMessages } from './errors.ts';
import { del, get, put } from './fetch.ts';

export type WebAuthnCredentialListItem = {
  id: string;
  name: string;
  /** Model name resolved from the credential's AAGUID, e.g. "YubiKey 5C NFC", "Apple Passwords". Null when unknown. */
  authenticatorName: string | null;
  createdAt: string;
  lastSeenAt: string | null;
};

// GET /webauthn-authenticators
export type GetAuthenticatorsResult = WebAuthnCredentialListItem[];
export function getAuthenticators(init?: RequestInit) {
  return get<GetAuthenticatorsResult>('/v1/webauthn-authenticators', init);
}

// PUT /webauthn-authenticators/:id
export type EditAuthenticatorResult = WebAuthnCredentialListItem;
export type EditAuthenticatorVariables = {
  id: string;
  values: {
    name: string;
  };
};
export function editAuthenticator({ id, values }: EditAuthenticatorVariables) {
  return put<EditAuthenticatorResult>(`/v1/webauthn-authenticators/${encodeURIComponent(id)}`, values);
}

// DELETE /webauthn-authenticators/:id
export type DeleteAuthenticatorResult = Record<string, never>;
export function deleteAuthenticator(id: string, init?: RequestInit) {
  return del<DeleteAuthenticatorResult>(`/v1/webauthn-authenticators/${encodeURIComponent(id)}`, init).catch(
    (err: unknown) => {
      return rewordValidationMessages(err, (details) => {
        if (details.code === 'ERR_ONLY_WEBAUTHN_AUTHENTICATOR_DELETION_DISALLOWED') {
          return 'You cannot delete your only remaining authenticator. Add another authenticator before deleting this one.';
        }
      });
    }
  );
}
